module.exports = __webpack_public_path__ + "img/image-landscape.0ebb0486.svg";